import { IconProps } from "../../types/utils";

const MessagesIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0016 4C7.59186 4 4.00334 7.34933 4.00334 11.4667C4.00817 12.9577 4.48185 14.4094 5.35776 15.616C5.15784 16.09 4.91422 16.5444 4.62987 16.9734L4.27262 17.5067C4.0554 17.8296 3.96316 18.2204 4.01337 18.6064C4.06358 18.9924 4.25272 19.3467 4.54526 19.6032C4.83779 19.8597 5.21383 20.0007 5.60308 20C7.09163 20.0022 8.54051 19.5193 9.73021 18.624C10.4698 18.83 11.234 18.9339 12.0017 18.9334C16.4115 18.9334 20 15.584 20 11.4667C20 7.34934 16.4115 4.00005 12.0017 4.00005L12.0016 4ZM12.0016 17.3333C11.1016 17.3339 10.2102 17.1572 9.37815 16.8132C8.38336 17.827 7.02318 18.3986 5.60309 18.3999L5.96035 17.8666C6.48109 17.076 6.8902 16.2172 7.17604 15.3147C6.1744 14.2833 5.61071 12.9044 5.60309 11.4667C5.60309 8.22671 8.4691 5.6 12.0017 5.6C15.5344 5.6 18.4004 8.22666 18.4004 11.4667C18.4004 14.7066 15.5344 17.3333 12.0017 17.3333H12.0016Z"
      fill={color || "#B3BCC8"}
    />
    <path
      d="M9.33218 11.467C9.33218 11.9088 8.974 12.2671 8.5323 12.2671C8.09062 12.2671 7.73242 11.9088 7.73242 11.467C7.73242 11.0253 8.0906 10.667 8.5323 10.667C8.97398 10.667 9.33218 11.0252 9.33218 11.467Z"
      fill={color || "#B3BCC8"}
    />
    <path
      d="M16.2658 11.467C16.2658 11.9088 15.9076 12.2671 15.4659 12.2671C15.0242 12.2671 14.666 11.9088 14.666 11.467C14.666 11.0253 15.0242 10.667 15.4659 10.667C15.9076 10.667 16.2658 11.0252 16.2658 11.467Z"
      fill={color || "#B3BCC8"}
    />
    <path
      d="M12.799 11.467C12.799 11.9088 12.4408 12.2671 11.9991 12.2671C11.5574 12.2671 11.1992 11.9088 11.1992 11.467C11.1992 11.0253 11.5574 10.667 11.9991 10.667C12.4408 10.667 12.799 11.0252 12.799 11.467Z"
      fill={color || "#B3BCC8"}
    />
  </svg>
);

export default MessagesIcon;
